import { render, staticRenderFns } from "./My.vue?vue&type=template&id=1e06867d"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"
import style0 from "./My.vue?vue&type=style&index=0&id=1e06867d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports